module.exports = __webpack_public_path__ + "static/media/dodgem(24).622a00e0.PNG";